// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wj-0";
export var confirmationIcon = "_wj-1";